import { graphql } from '../../../gql';

export const FOLLOW_USER = graphql(`
  mutation FollowUser($input: FollowUserInput!) {
    followUser(input: $input) {
      success
      message
      isFollowing
      followerCount
      followingCount
      followerId
      followedId
    }
  }
`);

export const UNFOLLOW_USER = graphql(`
  mutation UnfollowUser($input: UnfollowUserInput!) {
    unfollowUser(input: $input) {
      success
      message
      isFollowing
      followerCount
      followingCount
      followerId
      followedId
    }
  }
`);
